// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7c8688cc","239":"d2777a76","455":"88de5224","977":"1cd164ae"}[chunkId] + ".chunk.js";
};